import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { AppConfigService } from '@markant-platform/shared/data-access';

@Injectable()
export class PlatformAuthHttpInterceptor extends AuthHttpInterceptor {
  /**
   * skip Auth0 interceptor if Authorization-Header is already present
   *
   * @param req outgoing HTTPRequest
   * @param next httpHandler
   */
  override intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const basicAuthCredentials = AppConfigService.appConfiguration.basicAuthCredentials;
    let request = req;
    const url = this.stripQueryFromUrl(req.url);

    const isPublicRoute = AppConfigService.appConfiguration.publicEndpoints.some(endpoint => {
      const regex = new RegExp(`^${endpoint.route.replace(/\*/g, '.*').replace(/\//, '\\/')}$`);
      const isHttpMethodConfiguredForRoute =
        endpoint.httpMethods.length === 0 || endpoint.httpMethods.includes(req.method);

      return isHttpMethodConfiguredForRoute && regex.test(url);
    });

    if (!isPublicRoute) {
      return super.intercept(req, next);
    }

    if (basicAuthCredentials) {
      request = request.clone({
        headers: req.headers.set('Authorization', 'Basic ' + basicAuthCredentials),
      });
    }

    return next.handle(request);
  }

  private stripQueryFromUrl(url: string): string {
    const startsWithScope = url.indexOf('?' + 'scope') > -1;
    const hasAdditionalParams = url.indexOf('&') > -1;

    if (startsWithScope) {
      if (hasAdditionalParams) {
        url = url.substring(0, url.indexOf('&'));
      }
    } else if (url.indexOf('?') > -1) {
      url = url.substring(0, url.indexOf('?'));
    }

    if (url.indexOf('#') > -1) {
      url = url.substring(0, url.indexOf('#'));
    }

    return url;
  }
}
